import { Button } from '@talentmesh/ui/components/button';
import { Separator } from '@talentmesh/ui/components/separator';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { TypographyH2, TypographyH3, TypographyP } from '@talentmesh/ui/components/typography';
import { ReactNode } from 'react';
import CompanyDescriptionSection from './CompanyDescription';
import CompanyNameSection from './CompanyNameSection';
import SubdomainSection from './SubdomainSection';
import UIStrings from '@/Utils/UIStrings';

interface CompanyProfileFormProps {
    loading?: boolean;
    children?: ReactNode;
}

const CompanyProfileForm = ({ loading, children }: CompanyProfileFormProps) => {
    return (
        <div className="flex flex-col items-start gap-6">
            <TypographyH2>{UIStrings.CompanyProfile}</TypographyH2>
            <div className="flex w-full flex-col gap-6">
                <CompanyNameSection />
                <SubdomainSection />
                <CompanyDescriptionSection />
            </div>
            <Button data-cy="CompanyProfileSubmitButton" disabled={loading} type="submit">
                {loading && <Spinner className="mr-2 size-4" />}
                {UIStrings.Save}
            </Button>
            <div className="flex w-full flex-col gap-6">
                <Separator />
                <div className="flex flex-col gap-2">
                    <TypographyH3>{UIStrings.BrandElements}</TypographyH3>
                    <TypographyP>{UIStrings.UploadYourLogoAndIconHereToShowcaseYourCompany}</TypographyP>
                    <TypographyP>{UIStrings.CompanyBrandElementsValidationDescription}</TypographyP>
                </div>
                {children}
            </div>
        </div>
    );
};

export default CompanyProfileForm;
